import React from 'react'
import './Flash.css'
import {
    FavoriteBorderOutlined,
    ShoppingCartOutlined,
  } from "@material-ui/icons";
  

const Flash = () => {
  return (
    <div>
        <div className="parent4">

<div className="div17">
   <img src="https://shop.activeitzone.com/public/uploads/all/ix013yiczU4DZ4314gNCZTAljB2smAIRJV3ExsBC.png" alt="" width="38%" height="130px"/>
   <div className="sub">
      <div className="upper-text"><span className="side"> $150.00</span>$150.00</div>
      
      <div className="text1">Nike Sportswear Storm-FIT <br/> Windrunner</div>
      
      <div className="lower">
      <ShoppingCartOutlined fontSize="medium" />
          &nbsp; Buy Now
          <FavoriteBorderOutlined fontSize="medium" className="icon" />
      </div>
  </div>
</div>

<div className="div18">
   <img src="https://shop.activeitzone.com/public/uploads/all/zhD91QC7yQeUpuLDLiTug9bBporo0z9tyZv1hiHF.png" alt="" width="38%" height="140px"/>
   <div className="sub">
      <div className="upper-text"><span className="side"> $150.00</span>$150.00</div>
      
      <div className="text1">Nike Sportswear Storm-FIT <br/> Windrunner</div>
      
      <div className="lower">
      <ShoppingCartOutlined fontSize="medium" />
          &nbsp; Buy Now
          <FavoriteBorderOutlined fontSize="medium" className="icon" />
      </div>
  </div>
</div>



<div className="div19">
   <img src="https://shop.activeitzone.com/public/uploads/all/CBYD7muQopPffAO3De50AVnYbJwZl8zLKUEvxQeW.png" alt="" width="38%" height="140px"/>
   <div className="sub">
      <div className="upper-text"><span className="side"> $150.00</span>$150.00</div>
      
      <div className="text1">Nike Sportswear Storm-FIT <br/> Windrunner</div>
      
      <div className="lower">
      <ShoppingCartOutlined fontSize="medium" />
          &nbsp; Buy Now
          <FavoriteBorderOutlined fontSize="medium" className="icon" />
      </div>
  </div>
</div>


<div className="div20">
   <img src="https://shop.activeitzone.com/public/uploads/all/bKbaADHcAL5sQY2wDnALZ6Dk1vP37qXRmr3FP2rL.png" alt="" width="38%" height="140px"/>
   <div className="sub">
      <div className="upper-text"><span className="side"> $150.00</span>$150.00</div>
      
      <div className="text1">Nike Sportswear Storm-FIT <br/> Windrunner</div>
      
      <div className="lower">
      <ShoppingCartOutlined fontSize="medium" />
          &nbsp; Buy Now
          <FavoriteBorderOutlined fontSize="medium" className="icon" />
      </div>
  </div>
</div>


<div className="div21">
   <img src="https://shop.activeitzone.com/public/uploads/all/PqBt14kBFNlMKQQPgtvYVKs337vE0E2JHfZPZ5Qk.png" alt="" width="38%" height="140px"/>
   <div className="sub">
      <div className="upper-text"><span className="side"> $150.00</span>$150.00</div>
      
      <div className="text1">Nike Sportswear Storm-FIT <br/> Windrunner</div>
      
      <div className="lower">
      <ShoppingCartOutlined fontSize="medium" />
          &nbsp; Buy Now
          <FavoriteBorderOutlined fontSize="medium" className="icon" />
      </div>
  </div>
</div>


<div className="div22">
   <img src="https://shop.activeitzone.com/public/uploads/all/d5rlPozS5kSPgvrlpdNWuGMKQFBXZJFWKrKMcJzH.png" alt="" width="38%" height="140px"/>
   <div className="sub">
      <div className="upper-text"><span className="side"> $150.00</span>$150.00</div>
      
      <div className="text1">Nike Sportswear Storm-FIT <br/> Windrunner</div>
      
      <div className="lower">
      <ShoppingCartOutlined fontSize="medium" />
          &nbsp; Buy Now
          <FavoriteBorderOutlined fontSize="medium" className="icon" />
      </div>
  </div>
</div>


</div>
    </div>
  )
}

export default Flash